import { render, staticRenderFns } from "./menu3_images_scence.vue?vue&type=template&id=5a54e780&scoped=true"
import script from "./menu3_images_scence.vue?vue&type=script&lang=js"
export * from "./menu3_images_scence.vue?vue&type=script&lang=js"
import style0 from "./menu3_images_scence.vue?vue&type=style&index=0&id=5a54e780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a54e780",
  null
  
)

export default component.exports